import _ from '@lodash';
import axios from "@fuse/utils/axios";
import { makeStyles } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useRouter from '@fuse/hooks/useRouter';
import { formatString } from '@fuse/utils/stringOperations';
import "ag-grid-enterprise";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'styles/ag-grid-header-style.css';
import useToast from '@fuse/hooks/useToast';
import { useState, useEffect, useRef } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { countries } from '@fuse/utils/countryName'
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import ActivityAgGridListing from '@fuse/components/ActivitieLogs/activitiesAgGridListing';
import DeleteConfirmModal from 'helper/DeleteConfirm';
import { handleFilterApplied } from 'helper/common';
import { openReportViewerDialog, setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import { openFormViewerDialog, setFromData } from '../store/formViewDialogReducer';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';

const useStyles = makeStyles({
	layoutRoot: {},
	searchbar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		margin: '5px 5px 5px 0',
		height: '28px'
	}
});

function ListView(props) {
	const classes = useStyles();
	const table_name = "SHIPPING";
	const [gridApi, setGridApi] = useState(null);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const [displayButton, setDisplayButton] = useState(false);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [locationDetails, setLocationDetails] = useState(false);
	const [filterApplied, setFilterApplied] = useState(false);

	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [tabValue, setTabValue] = useState(0)
	const [groupByArr, setGroupByArr] = useState([])
	const [logs, setLogs] = useState([]);
	const [loadingActivityLog, setLoadingActivityLog] = useState(false);
	const [isGridReady, setIsGridReady] = useState(0)

	const router = useRouter();
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	const gridRef = useRef();

	const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const tab_value = useSelector(
		(state) => state.reportApp.reportViewDialogReducer.tab_value
	);
	const [filterData, setFilterData] = useState(JSON.parse(sessionStorage.getItem('redirectFilter')));
	const [filterText, setFilterText] = useState();

	const tableHeaders = [
		"location_name", "address_1", "address_2", "city", "state", "zip", "country", "location_type_name", "no_of_assets", "source"
	];

	const onGridReady = (params) => {
		// setGridApi(params);
		gridRef.current = params
		setIsGridReady(isGridReady + 1)
		props.endUsersAccounts.forEach((list) => {
			for (const [fieldName, value] of Object.entries(list)) {
				if (value === "-" || value === "") {
					list[fieldName] = `No ${formatString(fieldName)}`;
				}
			}
		});
		if (router.query.report_name === undefined) {
			loadInitialState(params);
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		} else {
			setRowGroupPanelShow('always')
			getReport(params);
		}
	};

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	useEffect(() => {
		// onGridReady()
		return () => {
			dispatch(setQuickFilter(null))
		}
	}, [props.endUsersAccounts])

	function setHeaderName(header) {
		if (header === 'company_id') {
			return 'Company ID'
		} if (header === 'note_as_plain_text') {
			return 'Note'
		} if (header === "state") {
			return 'State/Province';
		}

		return header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')

	}

	function saveView(rows, filter, filterModelArr = null) {
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter: JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	function loadInitialState(params) {
		axios
			.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then((results) => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current = { ...gridRef.current, filterModelArr: filter }
					params?.api.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
					if (filter && Object.keys(filter)?.length) {
						setFilterApplied(true)
					}
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	// 	useEffect(()=>{
	//     if(filterApplied){
	//       toast.success("Filters have been applied")
	//     }
	//   },[filterApplied])

	function onSortChanged(params) {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows));
			saveView(rows);
		}
	}

	function onColumnMoved(params) {
		if (router.query.report_name === undefined) {
			saveView(params.api.getColumnState());
			const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows))
		}
	}

	function onColumnPinned(params) {
		if (router.query.report_name === undefined) {
			saveView(params.api.getColumnState());
			const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows))
		}
	}

	function onColumnVisible(params) {
		const rows = params.api.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			if (router.query.report_name === undefined) {
				saveView(params.api.getColumnState());
			}
		}
	}

	const onKeyUp = (event) => {
		const searchItem = event.target.value;
		gridApi.api.setQuickFilter(searchItem);
	}

	const onGridSizeChanged = (params) => {
		// setWindowHeight(window.innerHeight - 320);
	}

	useEffect(() => {
		gridRef?.current?.api?.setQuickFilter(query_data);
	}, [query_data])

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;
		const rows = params.api.getCellRanges();
		if (rows.length != 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex != endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}

	}

	const clearSelection = () => {
		gridApi.api.clearRangeSelection();
	}

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		// to show No result found in column filter
		dispatch(setfilterlist(rows));
		gridRef.current = {...gridRef.current,filterModelArr:rows}
		saveView("N/A", rows, gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if (total_rows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}

	const onFirstDataRendered = (params) => {
		params.api.sizeColumnsToFit(4500);
	};

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();
		if (groupedColumns.length === 0) setGroupByArr([]);
		else setGroupByArr(groupedColumns);

		if (router.query.report_name === undefined) {
			const rows = event.api.getColumnState();
			const first_row = rows[0];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
				dispatch(setrowGroupModel(rows));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
			}
		}
	}

	function getReport(event) {
		const { report_name } = router.query;
		const table_name = "location";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
			.then(results => {
				const model = JSON.parse(results.data.data.filter);
				event.api.setFilterModel(model);
				const row_model = JSON.parse(results.data.data.row_model);
				event?.api.applyColumnState({ state: row_model });
			})
			.catch(err => {
				console.log(err);
			})
	}

	function handelDelete(id) {
		axios.delete(`/shipping/delete/${id}`).then((res) => {
			if (res.status === 201) {
				toast.error(res.data.message);
				handleClose()
				return
			}
			toast.success(res.data.message)
			handleClose()
			props.refresh()
		}).catch((err) => {
			handleClose()
			console.log(err)
			toast.error(err.data.message);
		})
	}


	function handelDeleteV2() {
		if (locationDetails.id !== undefined) {
			axios.delete(`/shipping/delete/${locationDetails.id}`).then((res) => {
				if (res.status === 201) {
					toast.error(res.data.message);
					handleClose()
					return
				}
				toast.success(res.data.message)
				handleClose()
				props.refresh()
			}).catch((err) => {
				handleClose()
				console.log(err)
				toast.error(err.data.message);
			})
		}
	}

	const handleClickOpen = () => {
		setOpenDeleteDialog(true);
	};

	const handleClose = () => {
		setOpenDeleteDialog(false);
	};

	function handelEdit(data) {
		dispatch(setFromData(data))
		dispatch(openFormViewerDialog())
	}

	function handelOpenDialouge(data) {
		handleClickOpen()
		setLocationDetails(data)
	}

	function onRowGroupOpenedAutoSize() {
		const allColumnIds = [];
		gridApi.api.getColumnState().forEach((column) => {
			// only auto-sizing the auto-generated group column
			if (column.colId === 'ag-Grid-AutoColumn') {
				allColumnIds.push(column.colId);
			}
		});
		gridApi.api.autoSizeColumns(allColumnIds, false);
	}

	function onCellValueChanged(e) {
		const payload = {
			address: e.data.address_1,
			city: e.data.city,
			country: e.data.country,
			edit_id: e.data.id,
			location: e.data.location_name,
			state: e.data.state,
			zip: e.data.zip,
			location_type_id: e.data?.location_type?.id || 0,
			note: e.data.note_as_plain_text || ''
		}
		if (!payload.location) {
			toast.error('Location Name is required')
			props.refresh()
			return
		} if (!payload.address) {
			toast.error('Address Line 1 is required')
			props.refresh()
			return
		} if (!payload.city) {
			toast.error('City is required')
			props.refresh()
			return
		} if (!payload.country) {
			toast.error('Country is required')
			props.refresh()
			return
		} if (!payload.state) {
			toast.error('State is required')
			props.refresh()
			return
		} if (!payload.zip) {
			toast.error('Zipcode is required')
			props.refresh()
			return
		}
		axios.post('/shipping/edit', payload).then(response => {
			if (response.status === 201) {
				toast.error(response.data.message)
				props.refresh()
			} else {
				toast.success('Location updated Successfully.')
				props.refresh()
			}
		}).catch(err => {
			console.log('212=>', err);
			toast.error('Something went wrong!')
		})
	}

	const openInNewTab = (url) => {
		window.open(url, "_blank", "noreferrer");
	};

	function redirectToAssetProfile(event) {
		if (event.value === 0) {
			return
		}
		// dispatch(setAssetsForRedirection(event.data.related_asset))
		// localStorage.setItem('manufacturer_id',event.data.id)
		openInNewTab(`/assets-list?location_id=${event.data.id}`)
		// router.push('/assets');
	}

	const handleChildClick = (value) => {
		setTabValue(value)
	};

	// Logs
	function formatLogs(data) {
		let { length } = data
		return data.map((item) => {
			const shipObject = {
				id: item.id,
				action_id: `act${length}`,
				action_date_and_time: item.created_at,
				location_name: item?.shipping?.location_name || item.location_name,
				name: item.user_name,
				action: item.action_name,
				description: item.comment,
				previous_value: item.previous_data,
				current_value: item.current_data,
				field_name: item.action_field_name,
				user_role: item.user_role_name,
			}
			length--
			return shipObject
		})
	}

	function getLogs() {
		setLoadingActivityLog(true)
		axios.get('/shipping/activities')
			.then(({ data }) => {
				setLoadingActivityLog(false)
				setLogs(formatLogs(data.data.activities));

			})
			.catch(err => {
				console.log('cannot fetch logs');
			})
	}

	useEffect(() => {
		(tabValue === 1) && getLogs()
	}, [tabValue])

	useEffect(() => {
		setTabValue(tab_value)
	}, [tab_value])

	function handleOpenForm() {
		dispatch(openFormViewerDialog())
	}

	const handleAddReport = () => {
		dispatch(openReportViewerDialog())
	}

	useEffect(() => {
		setTimeout(() => {
		const filterArray = filterData;
		if (filterArray && gridRef?.current?.api) {
			console.log('filterArray', filterArray, gridRef.current?.api)
			sessionStorage.removeItem("redirectFilter")
			handleFilterApplied(filterArray, gridRef.current?.api, true);
			setFilterData()
			if (Object.keys(filterArray?.filterModel)?.length) {
				setFilterApplied(true)
				setFilterText('User is currently viewing the Shipping location page with the following filters…');
			}

			setIsGridReady(isGridReady + 1)
		}
		}, 1000)
	}, [gridRef.current?.api])

	  const clearRedirectionFilter = () => {
		  setFilterApplied(false);
		  setFilterText()
	  }

	return (
		<>
			{(tabValue === 0) && <AgGridFilterGroupView
				tableRef={gridRef}
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="shipping"
				logs={logs}
				displayTableName="Locations"
				onClick={handleChildClick}
				onClickAddButton={handleOpenForm}
				clearRedirectionFilter={clearRedirectionFilter}
				onClickAddReportButton={handleAddReport}
				addPermission={props.addLocationPermission}
				key={isGridReady}
			/>}
			{(tabValue === 1) && (<ActivityAgGridListing module="shipping" logs={logs}
				displayTableName="Locations"
				onClickAddButton={handleOpenForm}
				loadingActivityLog={loadingActivityLog}
			/>)}

			{(tabValue === 0) && <div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 105,
					fontSize: '11px'
				}}
			>
				{filterApplied && <p style={{margin: '4px'}}>{filterText ?? "Filters have been applied"}</p>}
				<AgGridReact
					ref={gridRef}
                    theme="legacy"
					onGridReady={onGridReady}
					suppressRowClickSelection
					// Set the desired sheet name
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					onFirstDataRendered={onFirstDataRendered}
					animateRows
					rowData={props.endUsersAccounts}
					rowHeight={30}
					headerHeight={44}

					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}
					groupHeaderHeight={1}
					components={frameworkComponents}
					floatingFiltersHeight={40}

					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}

					onFilterChanged={onFilterChanged}

					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}

					cacheQuickFilter

					pagination
					defaultColDef={{
						enableRowGroup: true,
						resizable: true
					}}
					columnDefs={[{
						lockPosition: true,
						rowSelection: "single",
						width: 120,
						minWidth: 120,
						maxWidth: 120,
						suppressSizeToFit: true,
						headerName: "Actions",
						suppressMenu: true,          
						suppressHeaderMenuButton: true,
						sortable: false,
						pinned: 'right',
						className: "action_field",
						lockPinned: true,
						cellRenderer: ({ data }) => {
							if (data) {
								return (
									<>
										{props.updateLocationPermission && <Tooltip id="edit" title="Edit" placement="top">
											{/* <Icon
												style={{
													color: '#1d2939',
													paddingBottom: '5px',
													paddingRight:'30px',
													fontSize:'15px',
													cursor:'pointer'
												}}
													onClick={() => handelEdit(data) }>edit</Icon> */}
											<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-pencil" onClick={() => handelEdit(data)} />
										</Tooltip>}
										{props.deleteLocationPermission && <Tooltip id="delete" title="Delete" placement="top">
											{/* <Icon 
										style={{
											color: '#1d2939',
											paddingBottom: '3px',
											paddingRight:'30px',
											fontSize:'15px',
											cursor:'pointer'
										}}
										onClick={() => handelOpenDialouge(data) }>delete</Icon> */}
											<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-trash" onClick={() => handelOpenDialouge(data)} />
										</Tooltip>}
									</>
								)
							}
							return (<></>)

						}
					},
					...tableHeaders.map((header, index) => {
						if (
							header === 'address_1' || header === 'city' || header === 'state' || header === 'zip'
							|| header === 'location_name' || header === 'address_2' || header === 'note_as_plain_text' || header === "location_type_name"
						) {
							return {
								key: index,
								// onCellEditingStarted={onCellEditingStarted}
								field: header,
								suppressSizeToFit: true,
								suppressRowClickSelection: true,
								editable: header != "no_of_assets",
								headerName: setHeaderName(header),
								sortable: true,
								filter: "agTextColumnFilter",
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								flex: 1,
								minWidth: 200,
								valueFormatter: (params) => {
									if (params.colDef.field === "address_2" && !params.value) return 'No Address 2'
									if (params.colDef.field === "note_as_plain_text" && !params.value) return 'No Notes'
									params.value
								},
								onCellValueChanged,
							}
						}
						if (header === 'no_of_assets') {
							return {
								key: index,
								field: header,
								suppressSizeToFit: true,
								suppressRowClickSelection: true,
								headerName: "Number Of Assets",
								sortable: true,
								filter: "agTextColumnFilter",
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								flex: 1,
								minWidth: 200,
								cellRenderer: (event) => {
									if (event?.value) {
										return (<a
											style={{
												height: '10px',
												width: '10px',
												color: 'black',
												cursor: 'pointer',
												marginTop: '2px',
												borderRadius: '50%',
												// display: 'inline-block',
												display: 'flex',
												alignItems: 'center',
												gap: '10px'
											}}
											onClick={() => redirectToAssetProfile(event)}
										>
											<><span>{event.value}</span></>
										</a>)
									} 
									return <span>{event?.value}</span>
									
								}
							}
						}
						if (header === 'country') {
							return {
								key: index,
								field: header,
								suppressSizeToFit: true,
								suppressRowClickSelection: true,
								headerName: setHeaderName(header),
								sortable: true,
								filter: "agTextColumnFilter",
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								flex: 1,
								minWidth: 200,
								editable: true,
								onCellValueChanged,
								cellEditorParams: { values: countries.map(item => `${item.name}`) },
								// cellRendererFramework= 'GenderRenderer'
								cellEditor: 'agRichSelectCellEditor'
							}
						}
						if (header === 'source') {
							return {
								key: index,
								field: header,
								suppressSizeToFit: true,
								suppressRowClickSelection: true,
								headerName: setHeaderName(header),
								sortable: true,
								filter: "agTextColumnFilter",
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								flex: 1,
								minWidth: 200,
								cellEditorParams: { values: countries.map(item => `${item.name}`) },
								// cellRendererFramework= 'GenderRenderer'
								cellEditor: 'agRichSelectCellEditor'
							}
						}
						if (header === 'source') {
							return {
								key: index,
								field: header,
								suppressSizeToFit: true,
								suppressRowClickSelection: true,
								headerName: setHeaderName(header),
								sortable: true,
								filter: "agTextColumnFilter",
								headerComponent: (props) => (CustomFilter(props, header, gridRef)),
								flex: 1,
								minWidth: 200,
								enableRowGroup: true,
								cellEditorParams: { values: countries.map(item => `${item.name}`) },
								// cellRendererFramework= 'GenderRenderer'
								cellEditor: 'agRichSelectCellEditor'
							}
						}
						return <></>
					})]}
				/>
				{/* <DeleteModelDialog
					openDeleteDialog={openDeleteDialog}
					locationDetails={locationDetails}
					handelDelete={handelDelete}
					handleClose={handleClose}
				/> */}
				{
					openDeleteDialog &&

					<DeleteConfirmModal
						openAlerModal={openDeleteDialog}
						module="Location"
						handleCloseAlertModal={handleClose}
						handleAlertModal={handelDeleteV2}
					/>
				}
			</div>}
		</>
	);
}

export default ListView

function DeleteModelDialog(props) {
	return (
		<div>
			<Dialog
				open={props.openDeleteDialog}
				onClose={props.handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					Delete Location
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<h4>Are you sure to delete this Location named as <b>{props.locationDetails.location_name}</b>?</h4>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={props.handleClose}>Cancel</Button>
					<Button onClick={() => props.handelDelete(props.locationDetails.id)} autoFocus>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</div>

	)

}
